'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactRouter = require('react-router');

var _BaseList = require('../common/BaseList');

var _BaseList2 = _interopRequireDefault(_BaseList);

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _CaseUpdateModal = require('../page-case/main-details/CaseUpdates/CaseUpdateModal');

var _CaseUpdateModal2 = _interopRequireDefault(_CaseUpdateModal);

var _constants = require('../../constants');

var _utils = require('../../utils');

var _util = require('../../utils/util');

var _EmptyListHelpText = require('../page-tasks/EmptyListHelpText');

var _EmptyListHelpText2 = _interopRequireDefault(_EmptyListHelpText);

var _CaseTrackingHeader = require('./CaseTrackingHeader');

var _CaseTrackingHeader2 = _interopRequireDefault(_CaseTrackingHeader);

var _caseTrackingListRenderUtils = require('./caseTrackingListRenderUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var renderDate = _utils.TableRenderingUtils.renderDate,
    renderLawFirmAndAttorney = _utils.TableRenderingUtils.renderLawFirmAndAttorney,
    renderMoney = _utils.TableRenderingUtils.renderMoney,
    renderRegistrySharingEligibilityStatuses = _utils.TableRenderingUtils.renderRegistrySharingEligibilityStatuses,
    renderUnformatted = _utils.TableRenderingUtils.renderUnformatted,
    USER_FLOW = _constants.AppConstants.USER_FLOW,
    MightyVersionVisibility = {
  FREE_ONLY: 'free',
  PAID_ONLY: 'paid'
};
var CaseTrackingList = (_dec = (0, _mobxReact.inject)('CaseStore', 'Clients', 'SessionStore', 'UiStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(CaseTrackingList, _Component);

  function CaseTrackingList(props) {
    _classCallCheck(this, CaseTrackingList);

    var _this = _possibleConstructorReturn(this, (CaseTrackingList.__proto__ || Object.getPrototypeOf(CaseTrackingList)).call(this, props));

    _initDefineProp(_this, 'currentPageNumber', _descriptor, _this);

    _initDefineProp(_this, 'data', _descriptor2, _this);

    _initDefineProp(_this, 'overlayContainer', _descriptor3, _this);

    _initDefineProp(_this, 'selectedRows', _descriptor4, _this);

    _initDefineProp(_this, 'showUpdateModal', _descriptor5, _this);

    _this.caseIdKey = null;
    _this.searchString = null;
    var isMightyFreeUser = _this.props.SessionStore.isMightyFreeUser;

    _this.caseIdKey = isMightyFreeUser ? 'id' : 'case_id';
    return _this;
  }

  _createClass(CaseTrackingList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.searchString === 'INITIAL') {
        return;
      }

      this.fetchTableData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.searchString !== nextProps.searchString) {
        this.searchString = nextProps.searchString;
        this.fetchTableData();
      }
    }
  }, {
    key: 'handleQuickUpdateButtonClick',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(caseId) {
        var _props, CaseStore, caseTrackingPage, SessionStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, CaseStore = _props.CaseStore, caseTrackingPage = _props.UiStore.caseTrackingPage, SessionStore = _props.SessionStore;

                caseTrackingPage.loading = true;
                SessionStore.trackEvent('TRACKING_UPDATE_FROM_LIST_PAGE', { case_id: caseId });
                _context.next = 5;
                return CaseStore.retrieve(caseId, { caseOnly: true });

              case 5:
                this.updateCase = _context.sent;

                this.showUpdateModal.setTrue();
                caseTrackingPage.loading = false;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleQuickUpdateButtonClick(_x) {
        return _ref.apply(this, arguments);
      }

      return handleQuickUpdateButtonClick;
    }()
  }, {
    key: 'handlePagination',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(page) {
        var query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = _urijs2.default.parse(page).query;


                this.currentPageNumber = (0, _util.setPagination)(query);
                _context2.next = 4;
                return this.fetchTableData(true);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handlePagination(_x2) {
        return _ref2.apply(this, arguments);
      }

      return handlePagination;
    }()
  }, {
    key: 'filterOutSelectedRowsNotInData',
    value: function filterOutSelectedRowsNotInData(idKey) {
      var _this2 = this;

      return this.selectedRows.filter(function (selectedRow) {
        return _this2.data.find(function (fetchedDataRow) {
          return fetchedDataRow[idKey] === selectedRow[idKey];
        });
      });
    }
  }, {
    key: 'toastSuccessIfCasesWithNoTrackingContactsHaveBeenFilteredOut',
    value: function toastSuccessIfCasesWithNoTrackingContactsHaveBeenFilteredOut() {
      var caseTrackingPage = this.props.UiStore.caseTrackingPage;

      if ('has_tracking_contact_email' in caseTrackingPage.query) {
        // this branch has no coverage due to router never triggering a refresh event from tests
        // istanbul ignore next
        _utils.toast.success('Cases without tracking contact emails have been filtered out. Now you can request case status updates.');
      }
    }
  }, {
    key: 'fetchTableData',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var paginating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _props2, caseTrackingPage, funder, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props2 = this.props, caseTrackingPage = _props2.UiStore.caseTrackingPage, funder = _props2.FunderStore.funder;

                caseTrackingPage.loading = true;

                if (!paginating) {
                  this.currentPageNumber = '1';
                }

                _context3.prev = 3;
                _context3.next = 6;
                return this.clientRows.list({ params: _extends({}, caseTrackingPage.query, { page: this.currentPageNumber }) });

              case 6:
                data = _context3.sent;

                this.data = data.results;

                caseTrackingPage.total = data.count;
                caseTrackingPage.tableData = (0, _caseTrackingListRenderUtils.serializeColumns)(funder.mighty_service_tier, this.data);
                caseTrackingPage.nextPageURL = data.next;
                caseTrackingPage.previousPageURL = data.previous;
                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](3);

                _utils.toast.error('There was an error fetching the case tracking list.');
                throw _context3.t0;

              case 18:
                _context3.prev = 18;

                caseTrackingPage.loading = false;
                this.selectedRows = this.filterOutSelectedRowsNotInData(this.caseIdKey);
                return _context3.finish(18);

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 14, 18, 22]]);
      }));

      function fetchTableData() {
        return _ref3.apply(this, arguments);
      }

      return fetchTableData;
    }()
  }, {
    key: 'updateCaseTrackingStatus',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(caseId, data) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.props.CaseStore.updateCaseTrackingStatus(caseId, data);

              case 2:
                _context4.next = 4;
                return this.fetchTableData();

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateCaseTrackingStatus(_x4, _x5) {
        return _ref4.apply(this, arguments);
      }

      return updateCaseTrackingStatus;
    }()
  }, {
    key: 'rowLocation',
    value: function rowLocation(state, rowInfo, column) {
      var case_id = (0, _get3.default)(rowInfo, 'original.case_id');
      return !!case_id && { pathname: '/case/' + case_id + '/details/feed', state: USER_FLOW.FROM_CASE_TRACKING_PAGE };
    }
  }, {
    key: 'onSelectRows',
    value: function onSelectRows(selectedCases) {
      var _this3 = this;

      var selectedDataRows = selectedCases && selectedCases.map(function (selectedCase) {
        return _this3.data.find(function (row) {
          return row[_this3.caseIdKey] === selectedCase;
        });
      });
      this.selectedRows = selectedDataRows.filter(function (s) {
        return s;
      });
    }
  }, {
    key: 'setListRef',
    value: function setListRef(ref) {
      this.overlayContainer = ref;
    }
  }, {
    key: 'onFilterOutCasesWithNoTrackingContacts',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref6) {
        var isReset = _ref6.isReset;
        var query;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                query = { has_tracking_contact_email: isReset ? null : true };
                _context5.next = 3;
                return this.props.onFilterChange(query);

              case 3:
                this.toastSuccessIfCasesWithNoTrackingContactsHaveBeenFilteredOut();

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onFilterOutCasesWithNoTrackingContacts(_x6) {
        return _ref5.apply(this, arguments);
      }

      return onFilterOutCasesWithNoTrackingContacts;
    }()
  }, {
    key: 'callScheduleBulkCaseTrackingTasksForSelectedCases',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this4 = this;

        var selectedCaseIds, numberOfUpdatesRequested;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                selectedCaseIds = this.selectedRows.map(function (row) {
                  return { case: row[_this4.caseIdKey] };
                }), numberOfUpdatesRequested = selectedCaseIds.length;
                _context6.next = 3;
                return this.props.Clients.caseTrackingUpdateTasks.create(selectedCaseIds);

              case 3:
                _utils.toast.success('Success! ' + numberOfUpdatesRequested + ' updates requested');

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function callScheduleBulkCaseTrackingTasksForSelectedCases() {
        return _ref7.apply(this, arguments);
      }

      return callScheduleBulkCaseTrackingTasksForSelectedCases;
    }()
  }, {
    key: 'onSendRequestUpdates',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                this.onFilterOutCasesWithNoTrackingContacts({ isReset: true });
                _context7.next = 4;
                return this.callScheduleBulkCaseTrackingTasksForSelectedCases();

              case 4:
                _context7.next = 9;
                break;

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7['catch'](0);

                _utils.toast.error('There was an error scheduling update requests');

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 6]]);
      }));

      function onSendRequestUpdates() {
        return _ref8.apply(this, arguments);
      }

      return onSendRequestUpdates;
    }()
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var isMightyFreeUser = this.props.SessionStore.isMightyFreeUser;

      return _react2.default.createElement(_CaseTrackingHeader2.default, {
        fetchTableData: this.fetchTableData,
        isMightyFreeUser: isMightyFreeUser,
        onFilterOutCasesWithNoTrackingContacts: this.onFilterOutCasesWithNoTrackingContacts,
        onSendRequestUpdates: this.onSendRequestUpdates,
        selectedRows: this.selectedRows
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var UiStore = this.props.UiStore;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_BaseList2.default, {
          columns: this.tableColumns,
          currentPageNumber: this.currentPageNumber,
          emptyText: this.emptyText,
          entityType: 'cases',
          handlePagination: this.handlePagination,
          handleSort: this.fetchTableData,
          onSelectRows: this.onSelectRows,
          pageStore: UiStore.caseTrackingPage,
          paginated: true,
          ref: this.setListRef,
          renderHeader: this.renderHeader,
          rowLocation: this.rowLocation,
          selectable: true,
          selectedRows: (0, _mobx.toJS)(this.selectedRows.map(function (selectedRow) {
            return selectedRow[_this5.caseIdKey];
          }))
        }),
        this.showUpdateModal.isTrue && _react2.default.createElement(_CaseUpdateModal2.default, {
          _case: this.updateCase,
          onClose: this.showUpdateModal.setFalse,
          onCreate: this.updateCaseTrackingStatus
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'clientRows',
    get: function get() {
      var _props3 = this.props,
          SessionStore = _props3.SessionStore,
          Clients = _props3.Clients;


      if (SessionStore.isMightyFreeUser) {
        return Clients.casePortfolio;
      }

      return Clients.openCaseSummary;
    }
  }, {
    key: 'tableColumns',
    get: function get() {
      var _props4 = this.props,
          isMightyFreeUser = _props4.SessionStore.isMightyFreeUser,
          _props4$FunderStore = _props4.FunderStore,
          isMedicalProvider = _props4$FunderStore.isMedicalProvider,
          isRegistryEnabled = _props4$FunderStore.isRegistryEnabled,
          plaintiffPrefix = isMightyFreeUser ? 'plaintiff__' : 'plaintiff_',
          columns = [{
        accessor: plaintiffPrefix + 'last_name',
        Cell: renderUnformatted,
        className: 'fs-mask',
        Header: 'Last Name',
        maxWidth: 130
      }, {
        accessor: plaintiffPrefix + 'first_name',
        Cell: renderUnformatted,
        className: 'fs-mask',
        Header: 'First Name',
        maxWidth: 130
      }, {
        accessor: 'tracking_follow_up_date',
        Cell: renderDate,
        Header: 'Follow up',
        maxWidth: 125,
        minWidth: 115
      }, {
        accessor: 'tracking_contact',
        Cell: _caseTrackingListRenderUtils.renderTrackingContact,
        clickable: false,
        Header: 'Tracking Contact',
        maxWidth: 180,
        minWidth: 120,
        overlayContainer: this.overlayContainer,
        visibility: MightyVersionVisibility.PAID_ONLY
      }, {
        accessor: isMightyFreeUser ? 'lawfirm__name' : 'lawfirm',
        Cell: renderLawFirmAndAttorney,
        Header: 'Law Firm & Attorney',
        maxWidth: 300
      }, {
        accessor: isMedicalProvider ? 'total_billing_amount_of_liens' : 'principal_amount',
        Cell: renderMoney,
        Header: isMedicalProvider ? 'Billing Amount' : 'Principal',
        maxWidth: 160,
        minWidth: 120,
        visibility: MightyVersionVisibility.PAID_ONLY
      }, {
        accessor: 'last_tracking_update',
        Cell: _caseTrackingListRenderUtils.renderLastCaseUpdate.bind(this, this.handleQuickUpdateButtonClick, !isMightyFreeUser),
        clickable: isMightyFreeUser,
        Header: 'Last Case Update',
        id: isMightyFreeUser ? 'tracking_summary__last_update_recorded_at' : 'last_tracking_update_recorded_at',
        minWidth: 100,
        sortable: true
      }],
          registryColumns = [{
        accessor: 'registry_sharing_eligibility',
        Cell: renderRegistrySharingEligibilityStatuses,
        Header: 'Law Firm Portal Eligibility',
        minWidth: 100,
        sortable: false
      }];


      if (isMightyFreeUser) {
        return columns.filter(function (column) {
          return column.visibility !== MightyVersionVisibility.PAID_ONLY;
        });
      }

      if (isRegistryEnabled) {
        return [].concat(columns, registryColumns);
      }

      return columns;
    }
  }, {
    key: 'emptyText',
    get: function get() {
      var _props5 = this.props,
          _props5$UiStore$caseT = _props5.UiStore.caseTrackingPage,
          filters = _props5$UiStore$caseT.filters,
          total = _props5$UiStore$caseT.total,
          isMightyFreeUser = _props5.SessionStore.isMightyFreeUser,
          actionText = _react2.default.createElement(
        'span',
        null,
        'To add new cases, navigate to our New Case Page ',
        _react2.default.createElement(
          _reactRouter.Link,
          { href: '/new-case' },
          _react2.default.createElement(
            'b',
            null,
            'here.'
          )
        )
      );

      if (isMightyFreeUser && (0, _isEmpty3.default)(filters) && total === 0) {
        return _react2.default.createElement(_EmptyListHelpText2.default, {
          actionText: actionText,
          subtitle: 'You have not added any cases yet!',
          title: 'This is your new Case Portfolio Page'
        });
      }

      return '';
    }
  }]);

  return CaseTrackingList;
}(_react.Component), _class3.propTypes = {
  CaseStore: _propTypes2.default.object.isRequired,
  Clients: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  onFilterChange: _propTypes2.default.func.isRequired,
  searchString: _propTypes2.default.string.isRequired,
  SessionStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'currentPageNumber', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '1';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'data', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'overlayContainer', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'selectedRows', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'showUpdateModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'handlePagination', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handlePagination'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = CaseTrackingList;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(renderDate, 'renderDate', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(renderLawFirmAndAttorney, 'renderLawFirmAndAttorney', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(renderMoney, 'renderMoney', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(renderRegistrySharingEligibilityStatuses, 'renderRegistrySharingEligibilityStatuses', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(renderUnformatted, 'renderUnformatted', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(USER_FLOW, 'USER_FLOW', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(MightyVersionVisibility, 'MightyVersionVisibility', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(CaseTrackingList, 'CaseTrackingList', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-tracking/CaseTrackingList.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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